import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MarkdownPipe } from "./pipes/markdown.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [MarkdownPipe],
  exports: [MarkdownPipe],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts